export default __webpack_public_path__ + "static/media/raw.bf6bd9a8.svg";